import Router from './router/Router';
import "./App.scss"
import PasswordModal from './components/PasswordModal/PasswordModal';
import { useState } from 'react';
function App() {
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(true);
  return (
    <>
    <PasswordModal isOpen={isPasswordModalOpen} onPasswordCorrect={() => {setIsPasswordModalOpen(false)}} />
      <div className="App">
        <Router />
      </div>
    </>
  );
}

export default App;
